import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedLock = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 30,
	viewBox: "0 0 29 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7.375 26.875C6.72187 26.875 6.16276 26.6424 5.69766 26.1773C5.23255 25.7122 5 25.1531 5 24.5V12.625C5 11.9719 5.23255 11.4128 5.69766 10.9477C6.16276 10.4826 6.72187 10.25 7.375 10.25H8.5625V7.875C8.5625 6.23229 9.14141 4.83203 10.2992 3.67422C11.457 2.51641 12.8573 1.9375 14.5 1.9375C16.1427 1.9375 17.543 2.51641 18.7008 3.67422C19.8586 4.83203 20.4375 6.23229 20.4375 7.875V10.25H21.625C22.2781 10.25 22.8372 10.4826 23.3023 10.9477C23.7674 11.4128 24 11.9719 24 12.625V24.5C24 25.1531 23.7674 25.7122 23.3023 26.1773C22.8372 26.6424 22.2781 26.875 21.625 26.875H7.375ZM14.5 20.9375C15.1531 20.9375 15.7122 20.7049 16.1773 20.2398C16.6424 19.7747 16.875 19.2156 16.875 18.5625C16.875 17.9094 16.6424 17.3503 16.1773 16.8852C15.7122 16.4201 15.1531 16.1875 14.5 16.1875C13.8469 16.1875 13.2878 16.4201 12.8227 16.8852C12.3576 17.3503 12.125 17.9094 12.125 18.5625C12.125 19.2156 12.3576 19.7747 12.8227 20.2398C13.2878 20.7049 13.8469 20.9375 14.5 20.9375ZM10.9375 10.25H18.0625V7.875C18.0625 6.88542 17.7161 6.04427 17.0234 5.35156C16.3307 4.65885 15.4896 4.3125 14.5 4.3125C13.5104 4.3125 12.6693 4.65885 11.9766 5.35156C11.2839 6.04427 10.9375 6.88542 10.9375 7.875V10.25Z",
		fill: "url(#paint0_linear_17319_62078)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_17319_62078",
		x1: 4.90002,
		y1: 27.2031,
		x2: 30.4971,
		y2: 14.5265,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedLock;
